import Fooji from '@fooji/microsites';
import { ErrorWithSetting } from './startWorkflow';
import { configStore } from '../stores/config';
import { get } from 'svelte/store';

export const notify = ({ error, errorMessage, additionalMetadata }: {
  errorMessage: string,
  error: any,
  additionalMetadata?: Record<string, unknown>,
}) => {
  return Fooji.Bugsnag.notify({
    errorMessage,
    error,
    jwt: localStorage.getItem('jwt') ?? undefined,
    additionalMetadata: {
      ...(additionalMetadata ?? {}),
      ...(error instanceof ErrorWithSetting ? error.metadata : {}),
      campaign: get(configStore)?.campaign ?? undefined
    }
  });
};
